var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center padding-tb-lg"},[_c('div',{staticStyle:{"color":"#bfbfc3"},attrs:{"to":"/featnet"},on:{"click":_vm.onClick}},[_c('span',{staticClass:"custom"},[_vm._v("多陪提供技术支持")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }